module.exports = __webpack_public_path__ + "img/_canada.967f5dc5.png";